import router from './router'
import endowmentMessages from './localization'

export default {
  router,
  localization: endowmentMessages,
}
